module.exports = __webpack_public_path__ + "f72823f3bc02bf77072ecdb8805170db.jpg";